export default "__VITE_ASSET__C_DTB3nY__"